// extracted by mini-css-extract-plugin
export default {"container":"section-panorama-view_container__34WRF","panoramaWrapper":"section-panorama-view_panoramaWrapper__vZrDV"};